import { useScheduleRoleMutation } from '../../features/SpeechAgendaApiSlice.ts'
import { useEffect, useState } from 'react'
import {
  formatAssignRoleResponse,
  parseErrorResponse,
} from '../../utils/FormatterUtils.ts'
import { BaseResponse } from '../../generated'
import {
  AssignRoleResponse,
  AssignRoleState,
  SpeechDetails,
} from '../../types/Types.ts'

export function useAssignRole(
  roleId: number | null | undefined,
  clubId: string | undefined,
  meetingTimestampUtc: string | undefined,
  selectedLinkedRoleId: number | undefined
): [
  AssignRoleResponse | null,
  AssignRoleState,
  (speechDetails?: SpeechDetails) => Promise<void>,
] {
  const [assignRoleState, setAssignRoleState] =
    useState<AssignRoleState>('NOT_STARTED')
  const [resultData, setResultData] = useState<AssignRoleResponse | null>(null)

  //Schedule Role
  const [scheduleRole, scheduleRoleResult] = useScheduleRoleMutation()
  const doRoleSchedule = async (speechDetails?: SpeechDetails) => {
    setAssignRoleState('PROCESSING')
    if (!clubId || !meetingTimestampUtc || !roleId) {
      console.error(
        `Missing required parameters for role scheduling: clubId: ${clubId}, meetingTimestampUtc: ${meetingTimestampUtc}, roleId: ${roleId}`
      )
      setAssignRoleState('ERROR')
      return
    }
    scheduleRole({
      clubId,
      meetingTimestampUtc,
      body: { roleId, linkedRoleId: selectedLinkedRoleId, ...speechDetails },
    })
  }

  //Assign Role Success
  useEffect(() => {
    if (
      !scheduleRoleResult.isLoading &&
      !scheduleRoleResult.isUninitialized &&
      scheduleRoleResult.data
    ) {
      const { title, description } = formatAssignRoleResponse(
        scheduleRoleResult.data
      )
      setResultData({ title, description })
      setAssignRoleState('SUCCESS')
    }
  }, [scheduleRoleResult])

  //Assign Role Error
  useEffect(() => {
    if (
      !scheduleRoleResult.isLoading &&
      !scheduleRoleResult.isUninitialized &&
      scheduleRoleResult.error
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const error = scheduleRoleResult.error.data as BaseResponse
      const { title, description } = parseErrorResponse(error)
      setResultData({ title, description })
      setAssignRoleState('ERROR')
    }
  }, [scheduleRoleResult])

  return [resultData, assignRoleState, doRoleSchedule]
}
